import React from 'react';
import { Button } from './ui/button';

const EmailReceiptModal = ({ isOpen, onClose, onSendReceipt, serviceName, amount, bookTitle }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 backdrop-blur-sm p-2 sm:p-4">
      <div className="bg-white rounded-2xl p-4 sm:p-6 md:p-8 max-w-md w-full shadow-2xl animate-fade-in">
        {/* Success Icon */}
        <div className="flex justify-center mb-4 sm:mb-6">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center">
            <span className="text-3xl sm:text-4xl">✅</span>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl sm:text-2xl font-bold text-center text-slate-900 mb-2 sm:mb-3 break-words">
          Generation Complete!
        </h3>

        {/* Details */}
        <div className="mb-4 sm:mb-6 space-y-2">
          <p className="text-center text-slate-600 text-sm sm:text-base break-words">
            Your <strong>{serviceName}</strong> has been successfully generated.
          </p>
          {bookTitle && (
            <p className="text-center text-xs sm:text-sm text-slate-500 italic break-words px-2">
              "{bookTitle}"
            </p>
          )}
          {amount && amount > 0 && (
            <p className="text-center text-slate-600 mt-4 text-sm sm:text-base">
              Amount charged: <strong>${amount.toFixed(2)}</strong>
            </p>
          )}
        </div>

        {/* Question */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
          <p className="text-center text-slate-700 font-medium text-xs sm:text-sm md:text-base break-words">
            Would you like an email receipt for this transaction?
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            onClick={onSendReceipt}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-sm sm:text-base py-2.5 sm:py-3"
          >
            📧 Yes, Send Receipt
          </Button>
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1 text-sm sm:text-base py-2.5 sm:py-3"
          >
            No Thanks
          </Button>
        </div>

        {/* Note */}
        <p className="text-[10px] sm:text-xs text-center text-slate-500 mt-3 sm:mt-4 break-words">
          Receipt will be sent to your registered email address
        </p>
      </div>
    </div>
  );
};

export default EmailReceiptModal;
